"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-godenzo": {
    "ebc8f958": [{
      "hkey": "29298b1f",
      "slug": "castagneto-petrognano",
      "name": "Castagneto-Petrognano",
      "primary": true,
      "skipSearch": false
    }],
    "petrognano": [{
      "hkey": "29298b1f",
      "slug": "castagneto-petrognano",
      "name": "Castagneto-Petrognano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b66a27fe": [{
      "hkey": "3fdc6340",
      "slug": "san-godenzo",
      "name": "San Godenzo",
      "primary": true,
      "skipSearch": false
    }],
    "eremo-chiesa": [{
      "hkey": "3fdc6340",
      "slug": "san-godenzo",
      "name": "San Godenzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0f5e4e09": [{
      "hkey": "3fdc6340",
      "slug": "san-godenzo",
      "name": "San Godenzo",
      "primary": true,
      "skipSearch": false
    }],
    "passo-del-muraglione": [{
      "hkey": "3fdc6340",
      "slug": "san-godenzo",
      "name": "San Godenzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5a06ea23": [{
      "hkey": "6698d92d",
      "slug": "il-castagno-d-andrea",
      "name": "Il Castagno d'Andrea",
      "primary": true,
      "skipSearch": false
    }],
    "castagno-d-andrea": [{
      "hkey": "6698d92d",
      "slug": "il-castagno-d-andrea",
      "name": "Il Castagno d'Andrea",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "01778c4f": [{
      "hkey": "29298b1f",
      "slug": "castagneto-petrognano",
      "name": "Castagneto-Petrognano",
      "primary": true,
      "skipSearch": false
    }],
    "petrograno-castagneto": [{
      "hkey": "29298b1f",
      "slug": "castagneto-petrognano",
      "name": "Castagneto-Petrognano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;